export const BreakPoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
};

export const FontWeights = {
  regular: 300,
  lessBold: 400,
  bold: 500,
};

export const ContentWidths = {
  sm: "510px",
  md: "690px",
  lg: "930px",
  xl: "1110px",
};
